import React from "react";
import { ArrowUpIcon } from "@chakra-ui/icons";
import ReportCard from "../ui/ReportCard";

import approved from "../../images/chart-success.png";

export default function ApprovedReports({ report }) {
  return <ReportCard title="Approved Reports" text={report} src={approved} />;
}
